import React from "react"
import classnames from "classnames"

import * as styles from "./Accordion.module.css"

export const Accordion = ({
  children,
  borderColor = "grey",
  initialTab,
  behaviorOnDesktop = "tabs",
  beautiful,
}: {
  children: JSX.Element[]
  borderColor?: string
  initialTab?: number
  behaviorOnDesktop?: "tabs" | "accordion"
  beautiful?: boolean
}) => {
  const [activeTab, setActiveTab] = React.useState(initialTab)

  return (
    <div
      className={classnames(styles.accordion, {
        [styles.tabView]: behaviorOnDesktop === "tabs",
        [styles.beautiful]: beautiful,
      })}
    >
      {children.map((x, index) => (
        <FullAccordionItem
          key={x.props.key}
          {...x.props}
          borderColor={borderColor}
          isOpen={activeTab === index}
          onClick={
            activeTab === index && behaviorOnDesktop === "accordion"
              ? () => setActiveTab(undefined)
              : () => setActiveTab(index)
          }
        />
      ))}
    </div>
  )
}

export const FullAccordionItem = ({
  title,
  children,
  borderColor,
  isOpen,
  onClick,
}: {
  title: string
  children: JSX.Element
  borderColor: string
  onClick: () => void
  isOpen: boolean
  withToggle?: boolean
}) => {
  return (
    <div
      className={classnames(styles.accordion__item, {
        [styles.accordion__item__isOpen]: isOpen,
      })}
      style={{ ["--border-color" as any]: borderColor }}
      onClick={onClick}
    >
      <h3 className={styles.accordion__item__title} onClick={onClick}>
        {title}

        <div
          className={classnames(styles.toggle, { [styles.close]: !isOpen })}
        ></div>
      </h3>
      <div
        onClick={event => event.stopPropagation()}
        className={styles.accordion__item__content}
      >
        {children}
      </div>
    </div>
  )
}

export const AccordionItem = ({
  title,
  children,
}: {
  title: string
  children: JSX.Element
}) => ({ children, type: "AccordionItem", key: title, props: { title } })
